export enum $jobTitle {
  _id = '_id',
  createdAt = 'createdAt',
  title = 'title',
  description = 'description',
  translationKey = 'translationKey',
  updatedAt = 'updatedAt',
}
